import { put, takeEvery } from 'redux-saga/effects';
import { SiteReliabilityAction, SiteReliabilityActionTypes, SiteReliabilityActions } from '../actions/SiteReliabilityActions';
import { IExperimentResponsePayload, IExperimentStartPayload, IExperimentStatusPayload, IExperimentStatusResponse, IPrometheusApiResponse } from '../../models/SiteReliabilityModels';
import siteReliabilityService from '../../services/SiteReliabilityServices';
import ISiteReliabilityState from '../state/SiteReliabilityState';

export function* postTriggerExperimentWorker(action: SiteReliabilityAction) {
    try {
        const body = action.data as IExperimentStartPayload;
        const response: IExperimentResponsePayload = yield siteReliabilityService.triggerExperiment(body)!;
        yield put(SiteReliabilityActions.triggerExperimentSuccess(response));
    } catch (error) {
      if (error instanceof Error) {
        yield put(SiteReliabilityActions.triggerExperimentError(error));
      }
    }
}

export function* postExperimentStatusWorker(action: SiteReliabilityAction) {
    try {
        const body = action.data as IExperimentStatusPayload;
        const response: IExperimentStatusResponse = yield siteReliabilityService.getExperimentStatus(body)!;
        yield put(SiteReliabilityActions.experimentStatusSuccess(response));
    } catch (error) {
      if (error instanceof Error) {
        yield put(SiteReliabilityActions.experimentStatusError(error));
      }
    }
}

export function* getPrometheusAPIWorker(action: SiteReliabilityAction) {
    try {
        const response: IPrometheusApiResponse = yield siteReliabilityService.getPrometheusData()!;
        yield put(SiteReliabilityActions.prometheusApiSuccess(response));
    } catch (error) {
      if (error instanceof Error) {
        yield put(SiteReliabilityActions.prometheusApiError(error));
      }
    }
}

export function* getFaultInjectionStatusWorker(action: SiteReliabilityAction) {
    try {
        const response: string = yield siteReliabilityService.getFisStatusString();
        yield put(SiteReliabilityActions.getFisStatusSuccess(response));
    } catch (error) {
      if (error instanceof Error) {
        yield put(SiteReliabilityActions.getFisStatusError(error));
      }
    }
}

export function* siteReliabilityWatcher() {
  yield takeEvery(SiteReliabilityActionTypes.TRIGGER_EXPERIMENT_START, postTriggerExperimentWorker);
  yield takeEvery(SiteReliabilityActionTypes.EXPERIMENT_STATUS_START, postExperimentStatusWorker);
  yield takeEvery(SiteReliabilityActionTypes.PROMETHEUS_API_START, getPrometheusAPIWorker);
  yield takeEvery(SiteReliabilityActionTypes.GET_FINJ_STATUS_START, getFaultInjectionStatusWorker);
}
